import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "relative mx-2" }
const _hoisted_2 = { class: "bg-black text-white text-xs rounded right-0 bottom-full text-left p-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-right pr-2 whitespace-nowrap" }
const _hoisted_5 = { class: "text-left pl-2 whitespace-nowrap" }
const _hoisted_6 = {
  key: 1,
  class: "w-64 text-left"
}
const _hoisted_7 = {
  key: 2,
  class: "img-container"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tooltip inline-block relative font-normal text-base flex flex-1 items-center", {
      'cursor-help': _ctx.message || _ctx.warnings || _ctx.image,
      'border-dotted border-b-2 border-gray-500':
        (_ctx.message || _ctx.warnings || _ctx.image) && _ctx.showDottedLine,
    }])
  }, [
    (_ctx.message || _ctx.warnings || _ctx.image)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["inner-container hidden absolute z-50 bottom-full transform mb-2", {
        'w-64': _ctx.extendWidth,
        'w-auto': !_ctx.extendWidth,
        '-left-5': _ctx.isRight,
        '-right-5': _ctx.isLeft,
        'left-1/2 -translate-x-1/2': _ctx.image,
      }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.message)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.isMessageArray && _ctx.message.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("table", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message, (item) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: item.key
                              }, [
                                _createElementVNode("td", _hoisted_4, _toDisplayString(item.key || ''), 1),
                                _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.methods.formatValue(item.value)), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.message), 1)
                        ], 64))
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.warnings)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warnings, (item) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: item,
                        class: "mb-1"
                      }, _toDisplayString(item), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.image)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: `data:image;base64,${_ctx.image}`
                    }, null, 8, _hoisted_8)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["absolute h-3 top-full", {
              'left-3.5': _ctx.isRight,
              'right-3.5': _ctx.isLeft,
              'left-1/2 transform -translate-x-1/2': _ctx.image,
            }]),
                viewBox: "0 0 255 255"
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("polygon", { points: "0,0 127.5,127.5 255,0" }, null, -1)
              ]))], 2))
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 2))
}